export const WhatsAppGreen = '#25D366';
export const GlintsLogoRed = '#FF4A5D';
export const GlintsCardShadow = {
  faint: 'rgba(63, 63, 68, 0.05) 0px 0px 0px 1px',
} as const;
